<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">Too Great a Burden to Bear</h1>
<p class="subtitle"><em>The Struggle and Failure of the Freedmen’s Bureau in Texas</em></p>
<p class="author">Christopher B. Bean</p>
<p class="pub"><img alt="Image" src="images/pub-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0b481ccf